import * as d3 from 'd3'

export const filterItemsByRange = (list, range) => {
  if (!list) return []
  const maxDate = d3.max(list.map(d => d.date))
  const minDate = d3.min(list.map(d => d.date))
  if (!maxDate || !minDate) return []
  let cutoffDate = new Date()
  switch (range) {
    case 0:
      cutoffDate = monthAdd(maxDate, -24)
      return list.filter(item => {
        return item.date >= d3.max([minDate, cutoffDate])
      })
      break

    case 1:
      cutoffDate = monthAdd(maxDate, -60)
      return list.filter(item => {
        return item.date >= d3.max([minDate, cutoffDate])
      })
      break

    case 2:
      cutoffDate = monthAdd(maxDate, -120)
      return list.filter(item => {
        return item.date >= d3.max([minDate, cutoffDate])
      })
      break

    default:
      return []
  }
}


export function monthAdd(date, month) {
  var temp = date;
  temp = new Date(date.getFullYear(), date.getMonth(), 1);
  temp.setMonth(temp.getMonth() + (month + 1));
  temp.setDate(temp.getDate() - 1);

  if (date.getDate() < temp.getDate()) {
    temp.setDate(date.getDate());
  }

  return temp;
}

function formatDate(date, format) {
  return d3.timeFormat(format)(new Date(date))
}

export const DateUtil = {
  formatDate,
}
